import { Component, TemplateRef, ViewChild } from '@angular/core';
import { ICustomCellComponent } from '@shared/modules/table/classes/ICustomCellComponent';

@Component({
  selector: 'app-multiplicity-table-cell',
  templateUrl: './multiplicity-table-cell.component.html',
  styleUrls: ['./multiplicity-table-cell.component.scss'],
})
export class MultiplicityTableCellComponent implements ICustomCellComponent {
  @ViewChild(TemplateRef, { static: true }) cellTemplate: TemplateRef<any>;
}
